import { StoreShelf } from '@whiz-cart/node-shared/models/shelf/storeShelf';

export const LOADING_SHELVES = 'LOADING_SHELVES';
export const LOAD_SHELVES = 'LOAD_SHELVES';
export const DELETE_SHELVES = 'DELETE_SHELVES';
export const RESTORE_SHELVES = 'RESTORE_SHELVES';

export const isLoading = () => ({ type: LOADING_SHELVES });
export const loadShelves = (shelves: StoreShelf[]) => ({ type: LOAD_SHELVES, payload: shelves });
export const deleteShelves = (storeGuid: string, shelfGuids: string[]) => ({ type: DELETE_SHELVES, payload: shelfGuids, storeGuid });
export const restoreShelves = (shelfGuids: string[]) => ({ type: RESTORE_SHELVES, payload: shelfGuids });
